/**
 * Startup file which initializes the AIOT Tree. You can access the exports
 * through <code>window.rml</code>.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/antd.scss";
import "@devowl-wp/react-folder-tree/style/style.scss";
import "@devowl-wp/react-folder-tree/style/theme-wordpress.scss";
import "./style/style.scss";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { ready } from "@devowl-wp/react-utils";
import { handleCorruptRestApi } from "@devowl-wp/utils";
import { firstCreatedToolbar } from "./backbone/mediaLibraryShared.js";
import { applyEmlGridLayout, applyMediaViews } from "./backbone/mediaViews.js";
import { ImmediateLicenseForm } from "./components/common/immediateLicenseForm.js";
import { Provider as AntdProvider } from "./components/common/provider.js";
import { mountCoverImageInput } from "./integrations/coverImageInput.js";
import { adjustLinks } from "./integrations/defaultFolder.js";
import { mountPreUploadUi } from "./integrations/preUploadUi.js";
import { applyRpmAttachmentPageHint, applyRpmUrlFieldHint } from "./integrations/rpmHint.js";
import { applyShortcutListIcon } from "./integrations/shortcut.js";
import { renderShortcutInfoContainer } from "./integrations/shortcutInfo.js";
import { assignRmlWarnDelete } from "./integrations/static.js";
import { StoredAppTree, store } from "./store/storedAppTree.js";
import { scheduleWpUploaderPatch } from "./upload/pluploadBindings.js";
import { bootMediaNewPhp } from "./upload/uploader.js";
import { domObserver } from "./utils/domObserver.js";
import { humanFileSize } from "./utils/fileSize.js";
import { hooks } from "./utils/legacyHooksNoop.js";
import { request } from "./utils/request.js";
import { rmlOpts } from "./utils/rmlOpts.js";
handleCorruptRestApi({
    [rmlOpts.restNamespace]: async ()=>{
        await request({
            location: {
                path: "/plugin",
                // `rmlOpts.restNamespace` uses the legacy namespace, for /plugin we need to force the new namespace
                namespace: "real-media-library/v1"
            }
        });
    }
});
domObserver({
    ".rml-shortcut-info-container": renderShortcutInfoContainer,
    ".attachment-details .setting[data-setting='url']": applyRpmUrlFieldHint,
    "body.post-type-attachment .misc-pub-section.misc-pub-attachment": applyRpmAttachmentPageHint,
    "input.rml-pre-upload-ui[type='hidden']": mountPreUploadUi,
    "input.rml-cover-image-input": mountCoverImageInput,
    ".rmlShortcutSpan": applyShortcutListIcon
});
assignRmlWarnDelete();
adjustLinks();
bootMediaNewPhp();
scheduleWpUploaderPatch();
applyMediaViews();
ready(()=>{
    if (rmlOpts && $("body").hasClass("wp-admin") && ($("body").hasClass("upload-php") || $("body").hasClass("media_page_mla-menu"))) {
        const containerId = `rml${rmlOpts.others.blogId}`;
        applyEmlGridLayout();
        scheduleWpUploaderPatch();
        $("#wpbody").fadeTo(100, 1);
        $("body").addClass("activate-aiot");
        const $container = $("<div/>").prependTo("body.wp-admin #wpbody").addClass("rml-container");
        const container = $container.get(0);
        if (rmlOpts.others.listMode === "grid") {
            firstCreatedToolbar.done((attachmentsBrowser)=>{
                createRoot(container).render(/*#__PURE__*/ _jsx(StoredAppTree, {
                    attachmentsBrowser: attachmentsBrowser,
                    id: containerId
                }));
            });
        } else {
            createRoot(container).render(/*#__PURE__*/ _jsx(StoredAppTree, {
                id: containerId
            }));
        }
        if (rmlOpts.others.showLicenseFormImmediate && !window.Playwright) {
            createRoot(document.createElement("div")).render(/*#__PURE__*/ _jsx(AntdProvider, {
                children: /*#__PURE__*/ _jsx(ImmediateLicenseForm, {})
            }));
        }
    }
});
export { hooks, domObserver, rmlOpts, humanFileSize, store };
export * from "./events/index.js";
